import React, { useState, useRef, useEffect } from "react";
import "./CoinsPopup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";

import coins from '../imagesHome/coins.png';

const CoinsPopup = ({ coinCount }) => {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const popupRef = useRef(null);

  const closePopup = () => {
    if (closing) return; // previne spamul
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
      setOpen(false);
    }, 300); // să se potrivească cu animația din CSS
  };

  // Click în afara popup-ului
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Scroll block/unblock
  useEffect(() => {
    if (open) {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    } else {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    }
  }, [open]);

  return (
    <div className="coins-popup-container">
      <div className="oriented-coins-track" onClick={() => setOpen(true)}>
        <img src={coins} className="coins-popup-icon" />
        <div className="value-coins">{coinCount}</div>
      </div>

      {(open || closing) && (
        <>
          <div className="coins-popup-overlay" onClick={closePopup} />
          <div
            className={`coins-popup ${open ? "open" : ""} ${closing ? "closing" : ""}`}
            ref={popupRef}
          >
            <button className="coins-popup-close" onClick={closePopup}>×</button>
            <div className="coins-popup-content">
              <div className="coins-popup-number">{coinCount}</div>
              <img src={coins} className="coins-popup-bigicon" />
              <h3>Ai {coinCount} monede</h3>
              <p>Poți folosi monedele pentru a debloca lecții sau ajutoare.</p>
              <button className="coins-popup-btn">Cumpără monede</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CoinsPopup;
